var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBurgerMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_471_24842)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.6667 23.9999C27.0065 24.0003 27.3334 24.1304 27.5805 24.3637C27.8276 24.597 27.9763 24.9159 27.9962 25.2551C28.0161 25.5944 27.9058 25.9284 27.6876 26.189C27.4695 26.4496 27.1601 26.6171 26.8227 26.6573L26.6667 26.6666H5.33333C4.99349 26.6662 4.66662 26.5361 4.41951 26.3028C4.17239 26.0695 4.02369 25.7506 4.00377 25.4114C3.98385 25.0721 4.09423 24.7381 4.31235 24.4775C4.53047 24.2169 4.83987 24.0494 5.17733 24.0093L5.33333 23.9999H26.6667ZM26.6667 14.6666C27.0203 14.6666 27.3594 14.8071 27.6095 15.0571C27.8595 15.3072 28 15.6463 28 15.9999C28 16.3535 27.8595 16.6927 27.6095 16.9427C27.3594 17.1928 27.0203 17.3333 26.6667 17.3333H5.33333C4.97971 17.3333 4.64057 17.1928 4.39052 16.9427C4.14048 16.6927 4 16.3535 4 15.9999C4 15.6463 4.14048 15.3072 4.39052 15.0571C4.64057 14.8071 4.97971 14.6666 5.33333 14.6666H26.6667ZM26.6667 5.33325C27.0203 5.33325 27.3594 5.47373 27.6095 5.72378C27.8595 5.97383 28 6.31296 28 6.66659C28 7.02021 27.8595 7.35935 27.6095 7.60939C27.3594 7.85944 27.0203 7.99992 26.6667 7.99992H5.33333C4.97971 7.99992 4.64057 7.85944 4.39052 7.60939C4.14048 7.35935 4 7.02021 4 6.66659C4 6.31296 4.14048 5.97383 4.39052 5.72378C4.64057 5.47373 4.97971 5.33325 5.33333 5.33325H26.6667Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_471_24842"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurgerMenuIcon);
export default __webpack_public_path__ + "static/media/burger-menu-icon.0d212c6c14bc0f42cfc839d81c5a90ff.svg";
export { ForwardRef as ReactComponent };